/* eslint-disable no-console */
export default function messages(req, custom, component) {
  console.log(req, custom, component);
  const obj = {
    '-1': {
      type: 'error',
      title: 'Body e/ou Header fora do formato esperado',
    },
    '-2': {
      type: 'error',
      title: 'Recurso inválido / NULO',
    },
    '-3': {
      type: 'error',
      title: 'Recurso já cadastrado',
    },
    '-4': {
      type: 'error',
      title: 'Preencha todos os campos obrigatórios',
    },
    '-5': {
      type: 'error',
      title: 'Verifique os campos preenchidos e tente novamente',
    },
    '-6': {
      type: 'error',
      title: 'Campo não pode ser alterado',
    },
    '-9': {
      type: 'error',
      title: 'Recurso não encontrado',
    },
    '-99': {
      type: 'error',
      title:
        'Desculpe, estamos enfrentando uma indisponibilidade em nossos sistemas.',
      description: 'Por favor, tente novamente mais tarde.',
    },
    register: {
      '-3': {
        type: 'error',
        title: 'USUÁRIO JÁ CADASTRADO!',
        description: component,
      },
      '-12': {
        type: 'error',
        title: 'Número excedido de cadastros',
        description: 'Você excedeu o limite máximo de tentativas de cadastro!',
      },
      '-21': {
        type: 'error',
        title: 'Limite diário de tentativas de cadastro excedido!',
        description:
          'Você excedeu o limite diário de tentativas de cadastro. Por favor, tente novamente amanhã!',
      },
    },
    register_activation: {
      0: {
        type: 'success',
        title: 'O seu cadastro foi ativado com sucesso',
        description:
          'Informe os seus dados para continuar com o acesso. Esse login e senha também são válidos para entrar no App',
      },
      '-9': {
        type: 'error',
        title: '',
        description:
          'Desculpe, um erro ocorreu. Por favor, tente realizar seu login novamente e siga as orientações',
      },
      '-13': {
        type: 'error',
        title: 'Link expirado',
        description: 'Envie novamente o e-mail para ativação de cadastro',
      },
      '-16': {
        type: 'error',
        title: 'Link já foi validado',
        description:
          'Esse link já foi usado para ativar o seu cadastro. Tente enviar um novo para seu e-mail',
      },
    },
    register_activation_partner: {
      0: {
        type: 'success',
        title: 'Seu cadastro foi ativado com sucesso',
        description:
          'Para cadastrar ou alterar a senha do cartão, consultar saldo e outras funcionalidades, acesse o APP CAIXA Refeição e Alimentação, e tenha tudo na palma da sua mão.',
        presentation: 'PARABÉNS!',
        custom: true,
        store: true,
      },
      '-9': {
        type: 'error',
        title: '',
        description:
          'Desculpe, um erro ocorreu. Por favor, tente realizar seu login novamente e siga as orientações',
      },
      '-13': {
        type: 'error',
        title: 'Link expirado',
        description: 'Envie novamente o e-mail para ativação de cadastro',
      },
      '-16': {
        type: 'error',
        title: 'Link já foi validado',
        description:
          'Esse link já foi usado para ativar o seu cadastro. Tente enviar um novo para seu e-mail',
      },
    },
    login: {
      0: {
        type: 'success',
        title: '',
        description: component,
      },
      '-9': {
        type: 'error',
        title: 'Verifique se o email e/ou senha digitados estão corretos',
      },
      '-11': {
        type: 'error',
        title: 'Seu login foi desabilitado',
        description:
          'Por favor, entre em contato com a nossa Central de Atendimento',
      },
      '-12': {
        type: 'error',
        title: '',
        description: component,
      },
      '-15': {
        type: 'error',
        title: 'Confirmação de cadastro pendente',
        description: component,
      },
      '-16': {
        type: 'error',
        title: 'O Portal do Trabalhador foi descontinuado.',
        description:
          'Use o SuperApp VR e acesse todas as funções do portal e muito mais! \nLá você consulta saldos, extratos, pode fazer compras, pagar contas e outros.',
        custom: true,
      },
      '-20': {
        type: 'error',
        title: '',
        description: component,
      },
    },
    confirm_email: {
      0: {
        type: 'success',
        title: 'Confirmação de e-mail',
        description: component,
      },
    },
    forgot_password: {
      0: {
        type: 'success',
        title: 'Verifique seu e-mail',
        description: component,
      },
      '-9': {
        type: 'error',
        title: 'E-mail não encontrado.',
        description: 'Por favor, digite novamente',
      },
      '-14': {
        type: 'error',
        title: 'Não foi possível realizar essa ação',
        description: component,
      },
      '-15': {
        type: 'error',
        title: 'Não foi possível realizar essa ação',
        description: component,
      },
    },
    change_password: {
      0: {
        type: 'success',
        title: 'Senha cadastrada com sucesso',
        description: component,
      },
      '-9': {
        type: 'error',
        title: 'E-mail não encontrado.',
        description: 'Por favor, digite novamente',
      },
      '-13': {
        type: 'error',
        title: 'Link expirado',
        description: 'Insira novamente seu e-mail cadastrado',
      },
      '-16': {
        type: 'error',
        title: 'Link já foi validado',
        description:
          'Esse link já foi usado para alterar a senha. Tente novamente',
      },
      '-27': {
        type: 'error',
        title: '',
        description: 'Nova senha deve ser diferente das anteriores.',
      },
    },
    change_password_partner: {
      0: {
        type: 'success',
        title: 'Senha cadastrada com sucesso',
        description:
          'Para uma melhor experiência, acesse o app CAIXA Refeição e Alimentação e tenha todas as funcionalidades na palma da sua mão.',
        custom: true,
        store: true,
      },
      '-9': {
        type: 'error',
        title: 'E-mail não encontrado.',
        description: 'Por favor, digite novamente',
      },
      '-13': {
        type: 'error',
        title: 'Link expirado',
        description: 'Insira novamente seu e-mail cadastrado',
      },
      '-16': {
        type: 'error',
        title: 'Link já foi validado',
        description:
          'Esse link já foi usado para alterar a senha. Tente novamente',
      },
      '-27': {
        type: 'error',
        title: '',
        description: 'Nova senha deve ser diferente das anteriores.',
      },
    },
    change_card_password: {
      0: {
        type: 'success',
        title: '',
        description:
          'Senha alterada com sucesso! Você já pode usar o seu cartão',
      },
      '-19': {
        type: 'error',
        title: '',
        description: 'Esse cartão já foi validado',
      },
      '-23': {
        type: 'error',
        title: '',
        description: component,
      },
    },
    forgot_email: {
      '-9': {
        type: 'error',
        title: 'E-mail não encontrado.',
        description: 'Por favor, insira o seu CPF novamente',
      },
    },
    validate_card: {
      '-9': {
        type: 'error',
        title: '',
        description: component,
      },
      '-10': {
        type: 'error',
        title: '',
        description: component,
      },
      '-20': {
        type: 'error',
        title: '',
        description:
          'Seu cartão ainda não foi desbloqueado para uso. Por favor, entrar em contato com o seu RH',
      },
    },
    unlock_user: {
      0: {
        type: 'success',
        title: '',
        description: component,
      },
      '-9': {
        type: 'error',
        title: '',
        description:
          'Desculpe, um erro ocorreu. Por favor, tente realizar seu login novamente e siga as orientações',
      },
    },
    create_card_password: {
      0: {
        type: 'success',
        title: '',
        description:
          'Senha alterada com sucesso! Você já pode usar o seu cartão',
      },
      '-4': {
        type: 'error',
        title: 'Preencha todos os campos obrigatórios',
      },
      '-10': {
        type: 'error',
        description:
          'Dados não conferem! Por favor, tente novamente ou verifique se seus dados foram cadastrados corretamente com o seu RH',
      },
      '-22': {
        type: 'error',
        description: component,
      },
    },
    change_access_data: {
      0: {
        type: 'success',
        title: '',
        description:
          'Senha alterada com sucesso! Você já pode fazer login com a sua nova senha',
      },
      '-27': {
        type: 'error',
        description: component,
      },
      '-28': {
        type: 'error',
        description: component,
      },
      '-29': {
        type: 'error',
        description: 'A Senha atual não pode ser a mesma que a nova senha',
      },
    },
    lock_card: {
      0: {
        type: 'success',
        title: '',
        description:
          'Nova via solicitada! Cartão bloqueado e nova via solicitada com sucesso!',
      },
      '-21': {
        type: 'error',
        description: 'Ocorreu um erro ao tentar bloquear.',
      },
    },
    unlock_card: {
      0: {
        type: 'success',
        title: '',
        description: 'Cartão desbloqueado com sucesso',
      },
      '-9': {
        type: 'error',
        title: '',
        description:
          'Número inválido. Por favor, informe os 16 dígitos do seu cartão',
      },
      '-24': {
        type: 'error',
        title: '',
        description: component,
      },
      '-25': {
        type: 'error',
        title: '',
        description:
          'O desbloqueio do seu cartão deve ser feito pela sua empresa. Por favor, entrar em contato com o seu RH',
      },
    },
    quick_search: {
      '-9': {
        type: 'error',
        description: 'Cartão não encontrado',
      },
      '-25': {
        type: 'error',
        description:
          'Seu cartão ainda não foi desbloqueado para uso. Por favor, entrar em contato com o seu RH.',
      },
      '-30': {
        type: 'error',
        title: 'Número inválido',
        description:
          'Por favor, informe os 16 dígitos do seu cartão provisório',
      },
      '-31': {
        type: 'error',
        description: component,
      },
      '-32': {
        type: 'error',
        title: 'Consulta Rápida',
        description:
          'Esse tipo de consulta não está autorizada. Por favor, insira os 16 dígitos do seu cartão provisório',
      },
    },
    default: {
      type: 'error',
      title:
        'Desculpe, estamos enfrentando uma indisponibilidade em nossos sistemas.',
      description: 'Por favor, tente novamente mais tarde.',
    },
  };

  const customMsg =
    req.messages &&
    custom in obj &&
    obj[custom][req.messages[req.messages.length - 1].code];

  const msg = req.messages && obj[req.messages[req.messages.length - 1].code];

  return custom ? customMsg || msg || obj.default : msg || obj.default;
}
